<template>
  <div class="container">
    <div class="steps-container">
      <div class="steps-inner">
        <div
          class="step-item"
          @click="goToStep(step)"
          :class="{
            active: current_step === step,
            finish: current_step > step
          }"
          v-for="step in max_steps"
        >
          <span>{{ step }}</span>
        </div>
      </div>
    </div>

    <div class="steps-titles">
      <div
        v-if="stepTitle.title && stepTitle.title.length"
        class="title"
        v-html="stepTitle.title"
      ></div>
      <div
        v-if="stepTitle.sub_title && stepTitle.sub_title.length"
        class="sub-title"
        v-html="stepTitle.sub_title"
      ></div>
      <div
        v-if="stepTitle.small_sub_title && stepTitle.small_sub_title.length"
        class="small-sub-title"
        v-html="stepTitle.small_sub_title"
      ></div>
    </div>

    <template v-if="step_components[current_step - 1]">
      <component
        :key="current_step"
        :is="step_components[current_step - 1].component"
        v-bind="step_components[current_step - 1].props"
      ></component>
    </template>
  </div>
</template>

<script>
import { api } from "../../API";

import VacationTypeSelect from "./VacationTypeSelect.vue";
import VacationCountrySelect from "./VacationCountrySelect.vue";
import VacationMonthSelect from "./VacationMonthSelect.vue";
import VacationBudgetSelect from "./VacationBudgetSelect.vue";

export default {
  components: {
    VacationTypeSelect,
    VacationCountrySelect,
    VacationMonthSelect,
    VacationBudgetSelect
  },
  data() {
    return {
      siteData: window.siteData,
      max_steps: 6,
      current_step: 1,
      month_type: 0,
      selected_filters: {
        vacation_type_term: -1,
        vacation_type_term_2: -1,
        vacation_type_term_3: -1,
        country_term: -1,
        month_select: -1,
        date_range: -1,
        budget: -1
      },
      step_components: [
        {
          component: "VacationTypeSelect",
          props: {
            vacationTypes: window.siteData.vacation_types,
            filterKey: "vacation_type_term"
          }
        },
        {
          component: "VacationTypeSelect",
          props: {
            vacationTypes: window.siteData.vacation_types_2,
            filterKey: "vacation_type_term_2"
          }
        },
        {
          component: "VacationTypeSelect",
          props: {
            vacationTypes: window.siteData.vacation_types_3,
            filterKey: "vacation_type_term_3"
          }
        },
        {
          component: "VacationCountrySelect",
          props: {
            countries: window.siteData.countries
          }
        },
        {
          component: "VacationMonthSelect",
          props: {
            months: window.siteData.months
          }
        },
        {
          component: "VacationBudgetSelect",
          props: {
            min_budget: window.siteData.min_budget,
            max_budget: window.siteData.max_budget
          }
        }
      ]
    };
  },
  mounted() {
    window.eventBus.$on("searchVacation", searchBtn => {
      if (api.REQUESTING_VACATION) {
        return;
      }

      $(searchBtn)
        .btnLoader()
        .show();

      api.buildVacationQuery(this.selected_filters).then(res => {
        api.REQUESTING_VACATION = false;
        $(searchBtn)
          .btnLoader()
          .hide();
        window.location.href = `${window.location.href}?${res.query}`;
      });
    });

    window.eventBus.$on("nextStep", () => {
      if (
        this.current_step === 5 &&
        ((this.selected_filters.month_select === -1 && this.month_type === 1) ||
          (this.current_step === 5 &&
            this.selected_filters.date_range === -1 &&
            this.month_type === 0))
      ) {
        const $modal = $(".info-modal");
        $modal.find(".info-modal-title").html($t("חובה לבחור תאריך"));
        $modal
          .find(".info-modal-content")
          .html($t("חובה לבחור תאריך בלוח שנה או חודש ספציפי"));
        $modal.modal().show();
        return;
      }

      this.nextStep();
      $("body, html").animate(
        {
          scrollTop: 0
        },
        "slow"
      );
    });

    window.eventBus.$on("setMonthType", month => {
      this.month_type = month;
    });

    window.eventBus.$on("selectVacationType", data => {
      console.log(data);
      this.selected_filters[data.key] = data.term;
    });

    window.eventBus.$on("selectCountry", termId => {
      this.selected_filters.country_term = termId;
    });

    window.eventBus.$on("selectWholeMonth", month => {
      this.selected_filters.month_select = month;
    });

    window.eventBus.$on("selectRangeMonth", range => {
      this.selected_filters.date_range = range;
    });

    window.eventBus.$on("budgetChange", budget => {
      this.selected_filters.budget = budget;
    });
  },
  computed: {
    stepTitle() {
      return this.siteData.step_titles[this.current_step - 1];
    }
  },
  methods: {
    goToStep(step) {
      if (this.current_step === step || step > this.current_step) {
        return;
      }

      this.current_step = step;
    },
    nextStep() {
      if (this.current_step >= this.max_steps) {
        return;
      }

      this.current_step += 1;
    },
    prevStep() {
      if (this.current_step <= 1) {
        return;
      }

      this.current_step -= 1;
    }
  }
};
</script>
